import { render, staticRenderFns } from "./ReferralSidebar.vue?vue&type=template&id=fb47fd8e"
import script from "./ReferralSidebar.vue?vue&type=script&lang=js"
export * from "./ReferralSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReferralSidebar.vue?vue&type=style&index=0&id=fb47fd8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports